import { gql } from '@apollo/client';
import * as Sentry from '@sentry/nextjs';
import { query } from '../../../../Services/Gateway/Apollo';

/**
 * country needs to be ISO 3166-1 alpha-2 i.e. de, fr, gb, it, es
 */
const GET_APPOINTMENTS = gql`
  query getAppointments(
    $postcode: PostcodeInput!
    $provider: String!
    $locale: String
  ) {
    getAppointments(postcode: $postcode, provider: $provider, locale: $locale) {
      appointments {
        date
        location {
          name
          address
          distance
          locationId
          isMigrated
          shopIdPRM
        }
      }
    }
  }
`;

// eslint-disable-next-line import/prefer-default-export
export const getAppointments = async ({
  postcode,
  country,
  provider,
  locale,
}) => {
  if (!postcode || !country || !provider) return null;

  try {
    const result = await query({
      query: GET_APPOINTMENTS,
      variables: {
        postcode: { code: postcode, country: country.toUpperCase() },
        provider,
        locale,
      },
    });

    return result.data.getAppointments.appointments;
  } catch (error) {
    error.message = `Error in getting appointments query: ${error.message}`;
    Sentry.captureException(error);
    return null;
  }
};
